import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import udemyImage from '../../../assets/images/udemy.png';

const certificates = [
  {
    title: 'Ultimate Canva Course — Become a Freelance Graphic Designer',
    issuedBy: 'Udemy',
    date: '26 July 2025',
    image: udemyImage,
    link: 'https://drive.google.com/file/d/1NQ7vKNy2-q0ejYgLWA_KYYBaOrPVDG9j/view?usp=sharing'
  }
];

const UdemyCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Udemy"
      certificates={certificates}
    />
  );
};

export default UdemyCertificates;
